import React from 'react';
import {get as _get, isEmpty as _isEmpty} from 'lodash';
import {Header} from 'semantic-ui-react';
import {withRouter} from 'react-router';

import DefaultForm from '@appComponents/DefaultForm';
import {queryGetClipConfigForEventBooking} from '@graphql/eventEventBooking/query';
import {convertToInt} from '@utils/helpers';
import {getEventBookingDataFromAllSteps, generateTree}
    from '@modules/events/utils/EventEventBooking/eventBookingDataFromAllSteps';
import {
    editValidation,
    onCloseModal,
    prepareClipsTree,
    setMutationSuccess,
} from '@modules/eventBooking/forms/helpers/helpers';
import {showModalConfirmation} from '@utils/modal';
import { DELETE_CONFIRMATION, DELETE_HEADER, DELETED, NOT_DELETED } from '@constants/messages';
import {DeleteEventBooking} from '@graphql/eventEventBooking/mutation';
import {refetchQueryByName} from '@utils/apollo';
import {showMessageBox} from '@utils/messageBox';

export class EventBookingClipsEditForm extends DefaultForm {
    prepareDataForSubmit = () => {
        return getEventBookingDataFromAllSteps(this.props.stepsMethods, convertToInt(this.props.formParams.id));
    };

    onFormSubmit = (data) => {
        if (editValidation(this.props.stepsMethods)) {
            this.setState(() => ({
                defaultForm_loading: true,
            }));
            super.onFormSubmit(data);
        }
    };

    componentDidMount() {
        this.setUpdateSuccessCallback(() => {
            if (this.props.formParams.optionsVariables.event) {
                setMutationSuccess(this.props);
            }

            onCloseModal(
                this.props.formParams.optionsVariables.event,
                this.props.formParams.optionsVariables.client,
                this.props.Modal.setModal,
                this.props
            );
        });
        this.setDeleteSuccessCallback(() => {
            if (this.props.formParams.optionsVariables.event) {
                setMutationSuccess(this.props);
            }

            onCloseModal(
                this.props.formParams.optionsVariables.event,
                this.props.formParams.optionsVariables.client,
                this.props.Modal.setModal,
                this.props
            );
        });
    }

    componentDidUpdate(prevProps) {
        const {
            GraphQLEntityData,
        } = this.props;

        const eventEventBooking = _get(GraphQLEntityData, 'eventEventBooking');
        const productId = _get(eventEventBooking, 'product.id');
        const eventId = _get(eventEventBooking, 'event.id');
        const selectedObject = _get(eventEventBooking, 'event_content_type_configs');
        let objectToSelect = null;

        if (selectedObject && productId && eventId && !this.state.clipConfigsForEventBooking) {
            objectToSelect = selectedObject.map((selectedClip) => ({
                firstLevelTree: selectedClip.event_content_type.id,
                secondLevelTree: selectedClip.match_event_types.map(({id}) => id),
            }));

            prepareClipsTree(
                eventId,
                productId,
                this.state,
                (state) => this.setState(state),
                this.setField,
                this.runApolloRequest,
                queryGetClipConfigForEventBooking,
                this.props.MessageBox
            );
        }

        if (this.state.clipConfigsForEventBooking && !this.state.generatedClipConfigTreeEventBooking) {
            const eventEventBooking = _get(GraphQLEntityData, 'eventEventBooking');
            const selectedObject = _get(eventEventBooking, 'event_content_type_configs');

            objectToSelect = selectedObject.map((selectedClip) => ({
                firstLevelTree: selectedClip.event_content_type.id,
                secondLevelTree: selectedClip.match_event_types.map(({id}) => id),
            }));

            const tree = generateTree(this.state.clipConfigsForEventBooking, objectToSelect);

            if (!_isEmpty(tree)) {
                this.setField('clips', {
                    required: true,
                    options: tree,
                });
            }

            this.setState(() => ({generatedClipConfigTreeEventBooking: true}));
        }

        super.componentDidUpdate(prevProps);

        this.props.stepsMethods.setForm('step2', {formValues: this.props.formValues});
    }

    onCancel = () => {
        onCloseModal(
            this.props.formParams.optionsVariables.event,
            this.props.formParams.optionsVariables.client,
            this.props.Modal.setModal,
            this.props
        );
    };

    renderCancelButton = (props) => super.renderCancelButton({
        ...props,
        type: 'button',
        onClick: this.onCancel,
    });

    deleteButtonClick = (e) => {
        e.preventDefault();
        showModalConfirmation({
            header: <Header icon='trash' content={DELETE_HEADER(this.props.Model.entityLabel)}/>,
            text: DELETE_CONFIRMATION(this.props.Model.entityLabel),
            onYes: () => this.deleteEventBooking(this.props.formParams.id),
            onNo: () => this.onCancel(),
            size: 'tiny',
        });
    };

    deleteEventBooking = (id) => {
        this.runApolloRequest('mutate', {
            mutation: DeleteEventBooking,
            variables: {id},
        }).then(() => {
            this.onCancel();
            showMessageBox(
                'event',
                DELETED(this.props.Model.entityLabel),
                null,
                'success'
            );
            refetchQueryByName('GetEventsEventBookingsData');
        }).catch((error) => {
            this.onCancel();
            showMessageBox(
                'event',
                NOT_DELETED(this.props.Model.entityLabel),
                `${error}`,
                'error'
            );
        });
    };
}

export default withRouter(EventBookingClipsEditForm);
